import { render, staticRenderFns } from "./NewStudent.vue?vue&type=template&id=50fe701d&scoped=true"
import script from "./NewStudent.vue?vue&type=script&lang=js"
export * from "./NewStudent.vue?vue&type=script&lang=js"
import style0 from "./NewStudent.vue?vue&type=style&index=0&id=50fe701d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fe701d",
  null
  
)

export default component.exports